import checkout from '../modules/checkoutModule';
import basketFormInit from "../modules/basketFormInit";
import merchelloUi from '../libraries/merchello.ui';
import jqueryValidateUnobtrusive from '../libraries/jquery.validate.unobtrusive.min';
import header from '../modules/header/index';
import basketCounter from '../modules/basketCounter';
import basketText from '../modules/basketText';
import productCarousel from "../modules/productCarousel";
import addToCardEventInit from "../modules/addToCardEvent";
import beginCheckout from "../modules/beginCheckout";

jQuery(function() {
    header();
    jqueryValidateUnobtrusive();
    merchelloUi();
    checkout();
    basketFormInit();
    basketCounter();
    basketText();
    productCarousel();
    addToCardEventInit();
    beginCheckout();
});